(function() {
    angular.module('dma', [])
        .config(['$sceDelegateProvider', function($sceDelegateProvider) {

            $sceDelegateProvider.resourceUrlWhitelist([
                'self',
                'https://cdncn.melaleuca.com.cn/**',
                'https://cdnctcn.melaleuca.com/**',
                'https://cdntestcn.melaleuca.com/**'
            ]);
        }])
        .controller('digitalAssets', ['$scope', '$sce', '$timeout', function($scope, $sce, $timeout) {
            var vm = this;
            var custID = Number(PageClientData.Id);
            $scope.route = 'https://' + getHost() + '/html/business-center/landing-pages/digital-media-assets/card-' + wmCulture + '.html';
            console.log($scope.route)
            var showAllBtn = $('#show-all-btn');
            var imageBtn = $('#image-btn');
            var videoBtn = $('#video-btn');

            showAllBtn.on('click', function() {
                $timeout(function() {
                    $scope.cards = dmaobj;
                });
            });

            imageBtn.on('click', function() {
                var clickedBtn = $(this).find('span');

                var categoryList = dmaobj.filter(function(obj) {
                    if (clickedBtn.text().toLowerCase() === obj.category) {
                        return obj;
                    }
                });

                $timeout(function() {
                    $scope.cards = categoryList;
                });
            });


            // function refreshVideo() {
            //
            //   var categoryList =  dmaobj.filter(function (obj) {
            //       if ($('.dma-p').eq(0).text().toLowerCase() === obj.name) {
            //           return obj;
            //       }
            //   });
            //       $scope.cards = categoryList;
            // }
            //
            //         refreshVideo()



            videoBtn.on('click', function() {
                var clickedBtn = $(this).find('span');

                var categoryList = dmaobj.filter(function(obj) {
                    if (clickedBtn.text().toLowerCase() === obj.category) {
                        return obj;
                    }
                });

                $timeout(function() {
                    $scope.cards = categoryList;
                });
            });

            $scope.cards = dmaobj

            if (custID) {
                $scope.isqualified = true;
            } else {
                $scope.isqualified = false;
            }


            if (window.wm_cust_gv) {
                if (wm_cust_gv.wm_cust_status_value >= 11) {
                    $scope.isqualified = true;
                }
            }

            $scope.agreement = function(str, e) {
                console.log('1')
                var element = 'agreement__' + str + '__' + $(e.target).closest('.dma-card').data('sku');
                cmCreateElementTag(element, 'digital-media-assets', standardElementAnalyticsAttributes);
            };



            $timeout(function() {
                interactions();
            })


        }])
        .filter('trustAsHtml', ['$sce', function($sce) {
            return function(value) {
                return $sce.trustAsHtml(value);
            };
        }]);

    function interactions() {
        $('body').on('click', '.js-download-link', function() {
            $(this).closest('.dma-card').find('.js-agree').toggleClass('is-active');
        });

        $('body').on('mousedown', '.js-download-now', function() {
            var element = 'download__' + $(this).closest('.js-modal-copy-wrapper').data('sku');
            cmCreateElementTag(element, 'digital-media-assets', standardElementAnalyticsAttributes);
        });

        $('body').on('click', '.play-button', function() {
            var element = $(this).closest('.dma-card').data('sku');
            dmaobjPos = 99;
            locateSkuInObj($(this).closest('.dma-card').data('sku'));
            var modalheader = dmaobj[dmaobjPos].cardtitle,
                downloadpath = dmaobj[dmaobjPos].downloadpath,
                videoimage = dmaobj[dmaobjPos].videoimage,
                imageLink = dmaobj[dmaobjPos].imageLink,
                videoLongDescription = dmaobj[dmaobjPos].videoLongDescription,
                topPadding;
            switch (wmCulture) {
                case "zhCN":
                    var modalhtml = '<div class="modal-bg"><div class="modal-close js-close"></div><div class="modal-copy-wrapper js-modal-copy-wrapper" data-sku="' + element + '"><i class="fa fa-times-circle modal-close-x js-close" aria-hidden="true"></i><h2 class="js-modalheader">' + modalheader +
                        '</h2><p class="p">仅限个人在线观看，不可下载<span class="private-p"></span></p><div class="modal-center js-modal-center"></div><div class="share-wrapper"><div class="adownload"  download="' + modalheader + '.jpg"><p class="p download-now js-download-now"><div class="videoLongDescription">' + videoLongDescription + ' </div><img class="download-icon" src="//cdnus.melaleuca.com/Images/BusinessCenter/Landing_Page/digital-media-assets/download-icon.png"/><br><p class="video-reminder">视频加载时间根据您的网络情况会有所不同</p><br></p></div></div></div></div></div>';
                case "zhTW":
                    var modalhtml = '<div class="modal-bg"><div class="modal-close js-close"></div><div class="modal-copy-wrapper js-modal-copy-wrapper" data-sku="' + element + '"><i class="fa fa-times-circle modal-close-x js-close" aria-hidden="true"></i><h2 class="js-modalheader">' + modalheader +
                        '</h2><p class="p">仅限个人在线观看，不可下载<span class="private-p"></span></p><div class="videoLongDescription">' + videoLongDescription + '</div><div class="modal-center js-modal-center"></div><div class="share-wrapper"><a class="adownload" href="' + downloadpath + '" download="' + modalheader + '.jpg"><p class="p download-now js-download-now"> <img class="download-icon" src="//cdnus.melaleuca.com/Images/BusinessCenter/Landing_Page/digital-media-assets/download-icon.png"/><br><p class="video-reminder">视频加载时间根据您的网络情况会有所不同</p><br></p></a></div></div><div class="videoLongDescription">' + videoLongDescription + '</div></div>';
                default:
                    var modalhtml = '<div class="modal-bg"><div class="modal-close js-close"></div><div class="modal-copy-wrapper js-modal-copy-wrapper" data-sku="' + element + '"><i class="fa fa-times-circle modal-close-x js-close" aria-hidden="true"></i><h2 class="js-modalheader">' + modalheader +
                        '</h2><p class="p">仅限个人在线观看，不可下载<span class="private-p"></span></p><div class="modal-center js-modal-center"></div><div class="share-wrapper"><div class="adownload"  download="' + modalheader + '.jpg"><p class="p download-now js-download-now"><div class="videoLongDescription">' + videoLongDescription + ' </div><img class="download-icon" src="//cdnus.melaleuca.com/Images/BusinessCenter/Landing_Page/digital-media-assets/download-icon.png"/><br><p class="video-reminder">视频加载时间根据您的网络情况会有所不同</p><br></p></div></div></div></div></div>';
            }
            // if statement to avoid multiple modals
            if ($('.modal-bg').length === 0) {
                $('body').prepend(modalhtml);
                $('.download-icon').load(function() {
                    // get height from top of page (if user scrolled)
                    var offsetFromTop = $(document).scrollTop();
                    // if clicked item is a video
                    if (videoimage) {
                        $('.js-modal-center').html('<div class="js-jwplayer" id="js-jwplayer"></div>');
                        setupPlayer(downloadpath, videoimage);
                        // if video is being shown on mobile
                        if ($('.dma-wrapper').hasClass('dma-mobile')) {
                            topPadding = (($(window).height() - 270) / 2) > 60 ? (($(window).height() - 270) / 2) : 60;
                            // delay .3s to allow jwplayer to load into dom
                            setTimeout(function() {
                                // adjust width based on container width
                                var modalwidth = $(".modal-bg").width() < 600 ? (($(".modal-bg").width()) * 0.8) : 480;
                                // console.log(modalwidth);
                                $('.modal-copy-wrapper').css("top", offsetFromTop + topPadding).css("width", modalwidth);
                                var jsheight = (modalwidth * 0.563) > 270 ? 270 : (modalwidth * 0.563);
                                $('#js-jwplayer').css("width", "auto").css("height", jsheight);
                            }, 300);
                            // if video is being shown on desktop
                        } else {
                            //if desktop set width max
                            topPadding = (($(window).height() - 600) / 2) - 50 > 60 ? (($(window).height() - 600) / 2) - 50 : 60;
                            $('.modal-copy-wrapper').css("top", offsetFromTop + topPadding);
                        }
                        $('.modal-bg').css("height", $(document).height());
                        $('.manualdownload-now').html('');
                        // if clicked item is an image
                    } else {
                        // if image being shown on mobile
                        if ($('.dma-wrapper').hasClass('dma-mobile')) {
                            $('.js-modal-center').html('<img class="js-downloadpath" src="' + imageLink + '"/>');
                            var imageHeight = $(".js-downloadpath").height() || 270;
                            topPadding = (($(window).height() - imageHeight) / 2);
                            $('.js-downloadpath').load(function() {
                                $('.modal-copy-wrapper').css("top", offsetFromTop + topPadding).css("width", ($('.modal-bg').width()) * .8);
                            });
                            // if image being shown on desktop
                        } else {
                            $('.js-modal-center').html('<img class="js-downloadpath dma-full-size-img" src="' + imageLink + '"/>');
                            $('.js-downloadpath').load(function() {
                                var copyHeight = $('.modal-copy-wrapper').height(),
                                    docHeight = $(document).height(),
                                    totalHeight = copyHeight + offsetFromTop + 100;
                                if (totalHeight > docHeight) {
                                    offsetFromTop = docHeight - copyHeight - 100;
                                }
                                $('.modal-copy-wrapper').css("top", offsetFromTop).css("width", $(this).width());
                            });
                        }
                        $('.modal-bg').css("height", $(document).height());
                        $('.manualdownload-now').html('');
                    }
                    var wontAutoDownload = true;
                    if (navigator.platform == 'Win16' || navigator.platform == 'Win32' || navigator.platform == 'WinCE') wontAutoDownload = false;

                    if (wontAutoDownload) { $('.manualdownload').addClass('is-safari'); }
                });

                // after modal is up and ready, remove checked items and hide disclaimer
                setTimeout(function() { $('input').attr('checked', false);
                    $('.is-active').removeClass('is-active'); }, 1000);
            }
        });

        $('body').on('click', '.js-close, .js-radio-disagree', function() {
            $('.modal-bg').remove();
            $('.is-active').removeClass('is-active');
            setTimeout(function() {
                $('input').attr('checked', false);
            }, 500);
        });

        function locateSkuInObj(sku) {
            var tracker = 0;
            dmaobj.forEach(function() {
                if (dmaobj[tracker].sku == sku) {
                    dmaobjPos = tracker;
                }
                tracker++;
            });
        }

        function setupPlayer(_downloadpath, _videoimage) {
            try {
                var jwplayerInstance = jwplayer("js-jwplayer");
                jwplayerInstance.setup({
                    file: _downloadpath,
                    image: _videoimage,
                    height: 325,
                    width: 600,
                    autostart: true,
                    stretching: "uniform",
                });
            } catch (e) {
                console.log(e);
            }
        }
    }

    function getHost() {
        switch (location.host) {
            case "webcontentcn.melaleuca.com":
                return 'cdnctcn.melaleuca.com';
            case "webstcn.melaleuca.com":
                return 'cdntestcn.melaleuca.com';
            default:
                return 'cdncn.melaleuca.com.cn';
        }
    }
}());